import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Music } from "lucide-react";

const MusicPlayer = () => {
  return (
    <Card className="h-full col-span-1 md:col-span-2 lg:col-span-2 bg-white/40 backdrop-blur-md border-white/20 shadow-sm hover:shadow-md transition-all duration-300">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Music className="w-5 h-5 text-primary" />
          Calm Music
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4">
        <div className="aspect-video w-full rounded-lg overflow-hidden bg-muted">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/jfKfPfyJRdk?si=Xj8y8y8y8y8y8y8y"
            title="Calm Music Player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
          ></iframe>
        </div>
        <p className="text-xs text-muted-foreground mt-2 text-center">
          Curated playlist for focus and relaxation.
        </p>
      </CardContent>
    </Card>
  );
};

export default MusicPlayer;
